// TransactionList.jsx
import React from 'react';
import TransactionTable from '../TransactionTable';
import TabSwitcher from '../TabSwitcher';
import TablePaginators from 'components/Pagination/TablePaginator';
import { useDossierRole } from 'contexts/DossierRoleContext';

const TransactionList = ({
  combinedData,
  paginationIndex,
  setPaginationIndex,
  dataLength,
  pageSize,
  setPageSize,
  onActionSelected,
  selectedRows,
  handleRowSelect,
  onEyeClick,
  onDeleteClick,
  currentTab,
  setCurrentTab,
  handleFormDepense,
  handleFormVente,
  handleFormCreances,
  handleFormDettes,
  ajoutFou,
  viewArchived,
  allData, // Received from parent
  filters, // Received from parent
  onFilterChange, // Received from parent
  isMobile,
}) => {
  const { canEdit } = useDossierRole();
  return (
  <>
    <div className="HolderButtons">
      <div className="transaction-tabs-scroll">
        <TabSwitcher onTabChange={setCurrentTab} />
      </div>
      {canEdit && !isMobile && currentTab === 'out' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormDepense}
        >
          <span>+ Ajouter une sortie</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'in' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormVente}
        >
          <span>+ Ajouter une entrée</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'creances' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormCreances}
        >
          <span>+ Paiement du Client</span>
        </button>
      )}
      {canEdit && !isMobile && currentTab === 'dettes' && (
        <button
          type="button"
          className="btn btn-outline-dark"
          style={{
            borderRadius: '31px',
            border: '1px solid #AEAEAE',
            padding: '8px',
            ...ajoutFou,
          }}
          onClick={handleFormDettes}
        >
          <span>+ Paiement au Fournisseur</span>
        </button>
      )}
    </div>

    {canEdit && isMobile && (
      <div className="transaction-mobile-actions" aria-label="Actions rapides transactions">
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormVente}>
          + Entrée
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormDepense}>
          + Sortie
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormCreances}>
          + Paiement Client
        </button>
        <button type="button" className="transaction-mobile-action-btn" onClick={handleFormDettes}>
          + Paiement Fournisseur
        </button>
      </div>
    )}

    <TransactionTable
      data={combinedData || []} // Always render table, even if empty
      allData={allData}
      filters={filters}
      onFilterChange={onFilterChange}
      selectedRows={selectedRows}
      onSelectRow={handleRowSelect}
      onEyeClick={onEyeClick}
      onDeleteClick={onDeleteClick}
    />

    {allData && allData.length > 0 && (
      <TablePaginators
        paginationIndex={paginationIndex}
        setPaginationIndex={setPaginationIndex}
        dataLength={dataLength}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onActionSelected={onActionSelected}
        isViewingArchived={viewArchived}
      />
    )}
  </>
);
}

export default TransactionList;
